import { ParamType } from "../../../../poly/ParamType";
import { BaseConnectionPoint } from "./_Base";
import { Color } from "three";
import { Vector2 } from "three";
import { Vector3 } from "three";
import { Vector4 } from "three";
import { CoreType } from "../../../../../core/Type";
export var ActorConnectionPointType = /* @__PURE__ */ ((ActorConnectionPointType2) => {
  ActorConnectionPointType2["ANIMATION_MIXER"] = "AnimationMixer";
  ActorConnectionPointType2["ANIMATION_ACTION"] = "AnimationAction";
  ActorConnectionPointType2["BOOLEAN"] = "boolean";
  ActorConnectionPointType2["BOOLEAN_ARRAY"] = "boolean[]";
  ActorConnectionPointType2["BOX3"] = "Box3";
  ActorConnectionPointType2["COLOR"] = "color";
  ActorConnectionPointType2["COLOR_ARRAY"] = "color[]";
  ActorConnectionPointType2["FLOAT"] = "float";
  ActorConnectionPointType2["FLOAT_ARRAY"] = "float[]";
  ActorConnectionPointType2["INTEGER"] = "integer";
  ActorConnectionPointType2["INTEGER_ARRAY"] = "integer[]";
  ActorConnectionPointType2["MATERIAL"] = "Material";
  ActorConnectionPointType2["OBJECT_3D"] = "Object3D";
  ActorConnectionPointType2["PLANE"] = "Plane";
  ActorConnectionPointType2["RAY"] = "Ray";
  ActorConnectionPointType2["SPHERE"] = "Sphere";
  ActorConnectionPointType2["STRING"] = "string";
  ActorConnectionPointType2["STRING_ARRAY"] = "string[]";
  ActorConnectionPointType2["TRIGGER"] = "trigger";
  ActorConnectionPointType2["VECTOR2"] = "Vector2";
  ActorConnectionPointType2["VECTOR2_ARRAY"] = "Vector2[]";
  ActorConnectionPointType2["VECTOR3"] = "Vector3";
  ActorConnectionPointType2["VECTOR3_ARRAY"] = "Vector3[]";
  ActorConnectionPointType2["VECTOR4"] = "Vector4";
  ActorConnectionPointType2["VECTOR4_ARRAY"] = "Vector4[]";
  return ActorConnectionPointType2;
})(ActorConnectionPointType || {});
const PRIMITIVE_ACTOR_CONNECTION_TYPES = [
  "boolean" /* BOOLEAN */,
  "float" /* FLOAT */,
  "integer" /* INTEGER */,
  "string" /* STRING */
];
export function isActorConnectionPointPrimitive(type) {
  return PRIMITIVE_ACTOR_CONNECTION_TYPES.includes(type);
}
export const ACTOR_CONNECTION_POINT_TYPES = [
  "AnimationMixer" /* ANIMATION_MIXER */,
  "AnimationAction" /* ANIMATION_ACTION */,
  "boolean" /* BOOLEAN */,
  "boolean[]" /* BOOLEAN_ARRAY */,
  "Box3" /* BOX3 */,
  "color" /* COLOR */,
  "color[]" /* COLOR_ARRAY */,
  "float" /* FLOAT */,
  "float[]" /* FLOAT_ARRAY */,
  "integer" /* INTEGER */,
  "integer[]" /* INTEGER_ARRAY */,
  "Material" /* MATERIAL */,
  "Object3D" /* OBJECT_3D */,
  "Plane" /* PLANE */,
  "Ray" /* RAY */,
  "Sphere" /* SPHERE */,
  "string" /* STRING */,
  "string[]" /* STRING_ARRAY */,
  "trigger" /* TRIGGER */,
  "Vector2" /* VECTOR2 */,
  "Vector2[]" /* VECTOR2_ARRAY */,
  "Vector3" /* VECTOR3 */,
  "Vector3[]" /* VECTOR3_ARRAY */,
  "Vector4" /* VECTOR4 */,
  "Vector4[]" /* VECTOR4_ARRAY */
];
export const PARAM_CONVERTIBLE_ACTOR_CONNECTION_POINT_TYPES = [
  "boolean" /* BOOLEAN */,
  "color" /* COLOR */,
  "float" /* FLOAT */,
  "integer" /* INTEGER */,
  "string" /* STRING */,
  "Vector2" /* VECTOR2 */,
  "Vector3" /* VECTOR3 */,
  "Vector4" /* VECTOR4 */
];
export const ActorConnectionPointTypeToParamTypeMap = {
  ["AnimationMixer" /* ANIMATION_MIXER */]: ParamType.BUTTON,
  ["AnimationAction" /* ANIMATION_ACTION */]: ParamType.BUTTON,
  ["boolean" /* BOOLEAN */]: ParamType.BOOLEAN,
  ["boolean[]" /* BOOLEAN_ARRAY */]: ParamType.BUTTON,
  ["Box3" /* BOX3 */]: ParamType.BUTTON,
  ["color" /* COLOR */]: ParamType.COLOR,
  ["color[]" /* COLOR_ARRAY */]: ParamType.BUTTON,
  ["float" /* FLOAT */]: ParamType.FLOAT,
  ["float[]" /* FLOAT_ARRAY */]: ParamType.BUTTON,
  ["integer" /* INTEGER */]: ParamType.INTEGER,
  ["integer[]" /* INTEGER_ARRAY */]: ParamType.BUTTON,
  ["Material" /* MATERIAL */]: ParamType.BUTTON,
  ["Object3D" /* OBJECT_3D */]: ParamType.BUTTON,
  ["Plane" /* PLANE */]: ParamType.BUTTON,
  ["Ray" /* RAY */]: ParamType.BUTTON,
  ["Sphere" /* SPHERE */]: ParamType.BUTTON,
  ["string" /* STRING */]: ParamType.STRING,
  ["string[]" /* STRING_ARRAY */]: ParamType.BUTTON,
  ["trigger" /* TRIGGER */]: ParamType.BUTTON,
  ["Vector2" /* VECTOR2 */]: ParamType.VECTOR2,
  ["Vector2[]" /* VECTOR2_ARRAY */]: ParamType.BUTTON,
  ["Vector3" /* VECTOR3 */]: ParamType.VECTOR3,
  ["Vector3[]" /* VECTOR3_ARRAY */]: ParamType.BUTTON,
  ["Vector4" /* VECTOR4 */]: ParamType.VECTOR4,
  ["Vector4[]" /* VECTOR4_ARRAY */]: ParamType.BUTTON
};
export const ActorConnectionPointTypeToArrayTypeMap = {
  ["AnimationMixer" /* ANIMATION_MIXER */]: "AnimationMixer" /* ANIMATION_MIXER */,
  ["AnimationAction" /* ANIMATION_ACTION */]: "AnimationAction" /* ANIMATION_ACTION */,
  ["boolean" /* BOOLEAN */]: "boolean[]" /* BOOLEAN_ARRAY */,
  ["boolean[]" /* BOOLEAN_ARRAY */]: "boolean[]" /* BOOLEAN_ARRAY */,
  ["Box3" /* BOX3 */]: "Box3" /* BOX3 */,
  ["color" /* COLOR */]: "color[]" /* COLOR_ARRAY */,
  ["color[]" /* COLOR_ARRAY */]: "color[]" /* COLOR_ARRAY */,
  ["float" /* FLOAT */]: "float[]" /* FLOAT_ARRAY */,
  ["float[]" /* FLOAT_ARRAY */]: "float[]" /* FLOAT_ARRAY */,
  ["integer" /* INTEGER */]: "integer[]" /* INTEGER_ARRAY */,
  ["integer[]" /* INTEGER_ARRAY */]: "integer[]" /* INTEGER_ARRAY */,
  ["Material" /* MATERIAL */]: "Material" /* MATERIAL */,
  ["Object3D" /* OBJECT_3D */]: "Object3D" /* OBJECT_3D */,
  ["Plane" /* PLANE */]: "Plane" /* PLANE */,
  ["Ray" /* RAY */]: "Ray" /* RAY */,
  ["Sphere" /* SPHERE */]: "Sphere" /* SPHERE */,
  ["string" /* STRING */]: "string[]" /* STRING_ARRAY */,
  ["string[]" /* STRING_ARRAY */]: "string[]" /* STRING_ARRAY */,
  ["trigger" /* TRIGGER */]: "trigger" /* TRIGGER */,
  ["Vector2" /* VECTOR2 */]: "Vector2[]" /* VECTOR2_ARRAY */,
  ["Vector2[]" /* VECTOR2_ARRAY */]: "Vector2[]" /* VECTOR2_ARRAY */,
  ["Vector3" /* VECTOR3 */]: "Vector3[]" /* VECTOR3_ARRAY */,
  ["Vector3[]" /* VECTOR3_ARRAY */]: "Vector3[]" /* VECTOR3_ARRAY */,
  ["Vector4" /* VECTOR4 */]: "Vector4[]" /* VECTOR4_ARRAY */,
  ["Vector4[]" /* VECTOR4_ARRAY */]: "Vector4[]" /* VECTOR4_ARRAY */
};
const ARRAY_CONNECTION_TYPES = /* @__PURE__ */ new Set([
  "boolean[]" /* BOOLEAN_ARRAY */,
  "color[]" /* COLOR_ARRAY */,
  "float[]" /* FLOAT_ARRAY */,
  "integer[]" /* INTEGER_ARRAY */,
  "string[]" /* STRING_ARRAY */,
  "Vector2[]" /* VECTOR2_ARRAY */,
  "Vector3[]" /* VECTOR3_ARRAY */,
  "Vector4[]" /* VECTOR4_ARRAY */
]);
export const ActorParamTypeToConnectionPointTypeMap = {
  [ParamType.BOOLEAN]: "boolean" /* BOOLEAN */,
  [ParamType.BUTTON]: void 0,
  [ParamType.COLOR]: "color" /* COLOR */,
  [ParamType.FLOAT]: "float" /* FLOAT */,
  [ParamType.FOLDER]: void 0,
  [ParamType.INTEGER]: "integer" /* INTEGER */,
  [ParamType.PARAM_PATH]: void 0,
  [ParamType.NODE_PATH]: void 0,
  [ParamType.RAMP]: void 0,
  [ParamType.STRING]: "string" /* STRING */,
  [ParamType.VECTOR2]: "Vector2" /* VECTOR2 */,
  [ParamType.VECTOR3]: "Vector3" /* VECTOR3 */,
  [ParamType.VECTOR4]: "Vector4" /* VECTOR4 */
};
export const ActorConnectionPointInitValueMap = {
  ["AnimationMixer" /* ANIMATION_MIXER */]: null,
  ["AnimationAction" /* ANIMATION_ACTION */]: null,
  ["boolean" /* BOOLEAN */]: false,
  ["boolean[]" /* BOOLEAN_ARRAY */]: null,
  ["Box3" /* BOX3 */]: null,
  ["color" /* COLOR */]: new Color(),
  ["color[]" /* COLOR_ARRAY */]: null,
  ["float" /* FLOAT */]: 0,
  ["float[]" /* FLOAT_ARRAY */]: null,
  ["integer" /* INTEGER */]: 0,
  ["integer[]" /* INTEGER_ARRAY */]: null,
  ["Material" /* MATERIAL */]: null,
  ["Object3D" /* OBJECT_3D */]: null,
  ["Plane" /* PLANE */]: null,
  ["Ray" /* RAY */]: null,
  ["Sphere" /* SPHERE */]: null,
  ["string" /* STRING */]: "",
  ["string[]" /* STRING_ARRAY */]: null,
  ["trigger" /* TRIGGER */]: null,
  ["Vector2" /* VECTOR2 */]: new Vector2(),
  ["Vector2[]" /* VECTOR2_ARRAY */]: null,
  ["Vector3" /* VECTOR3 */]: new Vector3(),
  ["Vector3[]" /* VECTOR3_ARRAY */]: null,
  ["Vector4" /* VECTOR4 */]: new Vector4(),
  ["Vector4[]" /* VECTOR4_ARRAY */]: null
};
export const ActorConnectionPointComponentsCountMap = {
  ["AnimationMixer" /* ANIMATION_MIXER */]: 1,
  ["AnimationAction" /* ANIMATION_ACTION */]: 1,
  ["boolean" /* BOOLEAN */]: 1,
  ["boolean[]" /* BOOLEAN_ARRAY */]: 1,
  ["Box3" /* BOX3 */]: 1,
  ["color" /* COLOR */]: 3,
  ["color[]" /* COLOR_ARRAY */]: 1,
  ["float" /* FLOAT */]: 1,
  ["float[]" /* FLOAT_ARRAY */]: 1,
  ["integer" /* INTEGER */]: 1,
  ["integer[]" /* INTEGER_ARRAY */]: 1,
  ["Material" /* MATERIAL */]: 1,
  ["Object3D" /* OBJECT_3D */]: 1,
  ["Plane" /* PLANE */]: 1,
  ["Ray" /* RAY */]: 1,
  ["Sphere" /* SPHERE */]: 1,
  ["string" /* STRING */]: 1,
  ["string[]" /* STRING_ARRAY */]: 1,
  ["trigger" /* TRIGGER */]: 1,
  ["Vector2" /* VECTOR2 */]: 2,
  ["Vector2[]" /* VECTOR2_ARRAY */]: 2,
  ["Vector3" /* VECTOR3 */]: 3,
  ["Vector3[]" /* VECTOR3_ARRAY */]: 3,
  ["Vector4" /* VECTOR4 */]: 4,
  ["Vector4[]" /* VECTOR4_ARRAY */]: 4
};
export const ACTOR_CONNECTION_POINT_IN_NODE_DEF = {
  inNodeDefinition: true
};
export class ActorConnectionPoint extends BaseConnectionPoint {
  constructor(_name, _type, _options) {
    super(_name, _type);
    this._name = _name;
    this._type = _type;
    this._isArray = ARRAY_CONNECTION_TYPES.has(_type);
    if (_options) {
      this._inNodeDefinition = _options.inNodeDefinition == true;
      this._init_value = _options.init_value;
    }
    this._init_value = this._init_value || ActorConnectionPointInitValueMap[this._type];
    if (CoreType.isColor(this._init_value) || CoreType.isVector(this._init_value)) {
      this._init_value = this._init_value.clone();
    }
  }
  type() {
    return this._type;
  }
  get param_type() {
    const type = ActorConnectionPointTypeToParamTypeMap[this._type];
    if (type == ParamType.BUTTON) {
      return null;
    } else {
      return type;
    }
  }
  get init_value() {
    return this._init_value;
  }
  are_types_matched(srcType, destType) {
    return srcType == destType;
  }
  toJSON() {
    return this._json = this._json || this._create_json();
  }
  _create_json() {
    return {
      name: this._name,
      type: this._type,
      isArray: this._isArray
    };
  }
}
